import type { StringGUID } from "@pdfking/tfunc"

import { CreateRandom } from "../random/CreateRandom"
import { LoremTitle } from "./LoremWords"

export const AuthorName = (seed: StringGUID): string => LoremTitle(CreateRandom(seed, "author"), 2)
